import { DestroyRef } from "@angular/core";
import { ModelFormServiceFactory, modelFormServiceFactoryDepsToCtorArgs, modelFormServiceFactoryFacade } from "@common/forms/frontend-shared/form-service"; // deep import for tests (loading whole package leads to a weird babel error)
import { CrudItemFormService } from "./crud-item-form.service";
import * as i0 from "@angular/core";
function crudFormServiceFactoryFacade(deps) {
  return {
    ...modelFormServiceFactoryFacade(deps),
    createCrudFormService(ModelConstructor) {
      const fs = new CrudItemFormService(...modelFormServiceFactoryDepsToCtorArgs(deps));
      fs.setModel(ModelConstructor);
      return fs;
    }
  };
}
export let CrudFormServiceFactory = /*#__PURE__*/(() => {
  class CrudFormServiceFactory extends ModelFormServiceFactory {
    constructor() {
      super(...arguments);
      this.fallback = crudFormServiceFactoryFacade(this.deps);
    }
    useDestroyRef(destroyRef) {
      return crudFormServiceFactoryFacade({
        ...this.deps,
        destroyRef
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCrudFormServiceFactory_BaseFactory;
        return function CrudFormServiceFactory_Factory(__ngFactoryType__) {
          return (ɵCrudFormServiceFactory_BaseFactory || (ɵCrudFormServiceFactory_BaseFactory = i0.ɵɵgetInheritedFactory(CrudFormServiceFactory)))(__ngFactoryType__ || CrudFormServiceFactory);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CrudFormServiceFactory,
        factory: CrudFormServiceFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CrudFormServiceFactory;
})();